'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchEvent = exports.eventMap = exports.props = exports.EVENT_TICKET_UPDATE_SUCCESS = exports.EVENT_TICKET_REPLY_SUCCESS = exports.EVENT_TICKET_REPLY = undefined;

var _Event = require('../Core/Event');

/**
 * @type {string}
 */
var EVENT_TICKET_REPLY = exports.EVENT_TICKET_REPLY = 'context.ticket.reply';

/**
 * @type {string}
 */
/**
 * This module exports events available when the application context's Deskpro Object is a Ticket
 *
 * @module Context/eventsTicket
 */

var EVENT_TICKET_REPLY_SUCCESS = exports.EVENT_TICKET_REPLY_SUCCESS = 'context.ticket.reply-success';

/**
 * @type {string}
 */
var EVENT_TICKET_UPDATE_SUCCESS = exports.EVENT_TICKET_UPDATE_SUCCESS = 'context.ticket.update-success';

/**
 * @type {{EVENT_TICKET_REPLY: {channelType: string, invocationType: string}, EVENT_TICKET_REPLY_SUCCESS: {channelType: string, invocationType: string}, EVENT_TICKET_UPDATE_SUCCESS: {channelType: string, invocationType: string}}}
 */
var events = {

  EVENT_TICKET_REPLY: { channelType: _Event.CHANNEL_INCOMING, invocationType: _Event.INVOCATION_REQUESTRESPONSE },

  EVENT_TICKET_REPLY_SUCCESS: { channelType: _Event.CHANNEL_INCOMING, invocationType: _Event.INVOCATION_FIREANDFORGET },

  EVENT_TICKET_UPDATE_SUCCESS: { channelType: _Event.CHANNEL_INCOMING, invocationType: _Event.INVOCATION_FIREANDFORGET }
};

/**
 * @readonly
 * @enum
 * @type {{EVENT_TICKET_REPLY: {channelType: string, invocationType: string}, EVENT_TICKET_REPLY_SUCCESS: {channelType: string, invocationType: string}, EVENT_TICKET_UPDATE_SUCCESS: {channelType: string, invocationType: string}}}
 */
var props = exports.props = events;

/**
 * The map of events
 *
 * @type {EventMap}
 */
var eventMap = exports.eventMap = (0, _Event.buildMap)(events, props);

/**
 * Checks if an event is a Ticket event
 *
 * @function
 *
 * @param {string} eventName
 * @param {string} channelType
 * @param {string} invocationType
 * @return {boolean}
 */
var matchEvent = exports.matchEvent = function matchEvent(eventName, _ref) {
  var channelType = _ref.channelType,
      invocationType = _ref.invocationType;
  return (0, _Event.matchEvent)(eventName, { channelType: channelType, invocationType: invocationType }, eventMap);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Context/eventsTicket.js
// module id = 327
// module chunks = 0